import StringResolutionManager from 'models/managers/StringResolutionManager';
import {
  DedicatedLookupStructuredTableColumn,
  StructuredTable,
} from 'notebook/structured-tables/StructuredTableConstants';
import {removeQueryResolutionsFromSnapshot} from 'notebook/tables/excess/Resolver';
import {CustomResolutionQueryType} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {TableColumnType, TableOpDiffMap} from 'notebook/tables/TableConstants';

export function handleRefreshLookupStructuredTable({
  entryOrTemplateId,
  structuredTable,
}: {
  entryOrTemplateId: string;
  structuredTable: StructuredTable<unknown, unknown>;
}): void {
  const columns: Array<DedicatedLookupStructuredTableColumn> = [];
  const colIndexes: Array<number> = [];
  structuredTable.columns.forEach((column, idx) => {
    if (column.columnType === TableColumnType.DEDICATED_LOOKUP) {
      columns.push(column as DedicatedLookupStructuredTableColumn);
      colIndexes.push(idx);
    }
  });

  handleRefreshLookupColumns({
    entryOrTemplateId,
    tableProvenanceUuid: structuredTable.provenanceUuid,
    tableOp: {[structuredTable.name]: {type: 'eval-columns', colIndexes}},
    columns,
  });
}

export function handleRefreshLookupColumns({
  entryOrTemplateId,
  tableProvenanceUuid,
  tableOp,
  columns,
}: {
  entryOrTemplateId: string;
  tableProvenanceUuid: string;
  tableOp: TableOpDiffMap;
  columns: Array<DedicatedLookupStructuredTableColumn>;
}): void {
  const lookupConfigIds = columns.map((column) => column.lookupConfig.id);
  StringResolutionManager.clearStringResolutionReduxCacheByTypeAndId(
    CustomResolutionQueryType.LOOKUP_COLUMN,
    lookupConfigIds
  );

  removeQueryResolutionsFromSnapshot(entryOrTemplateId, tableProvenanceUuid, tableOp, lookupConfigIds);
}
